var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('session-table',{attrs:{"sessions":_vm.sessions,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }